<template />


<script>
import ParseFunctions from '@/components/ParseFunctions';
import Parse from 'parse'


export default {
  name: 'TeamMagicLink',
  mixins: [ParseFunctions],
  created() {
    let currentUser = Parse.User.current()
    if(currentUser){
      this.$router.push({
        path: '/',
        query: {
          token: this.$route.params.token,
          action: 'magic-link',
        }
      })
    }
    else {
      this.$router.push({
        path: '/register',
        query: {
          action: 'magic-link',
          token: this.$route.params.token,
        },
      })
    }
  }
}
</script>